import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Select from "react-select";
import { useDispatch } from "react-redux";
import { updateProfleAction } from "../../../redux/actions/user/userAction";
import { connect } from "react-redux";
import { useNavigatingAway } from "../../utils/core/blocknavigation/useNavigatingAway";
import { DialogLeavingPage } from "../../utils/core/blocknavigation/DialogLeavingPage";

export const Sector = (props) => {
  const customStyles = {
    control: (base, state) => ({
      ...base,
      top: "5px",
      // Overwrittes the different states of border
      borderColor: state.isFocused ? "#309CCA" : "#309CCA",
    }),
  };

  const dispatch = useDispatch();
  const [inputData, setInputData] = useState([]);
  const [errors, setErrors] = useState();

  const [isEnable, setIsEnable] = useState({
    save: false,
  });

  const [canShowDialogLeavingPage, setCanShowDialogLeavingPage] =
    useState(false);
  const [showDialogLeavingPage, confirmNavigation, cancelNavigation] =
    useNavigatingAway(canShowDialogLeavingPage);

  const handleValidations = (name, value) => {
    switch (name) {
      case "primary_sector":
        if (value === null) {
          const error = "Primary Sector is required!";
          setErrors({ ...errors, primary_sector: error });
        } else {
          setErrors({ ...errors, primary_sector: null });
        }
        break;
      case "primary_sector_experience":
        if (value === null) {
          const error = "Primary Sector Experience is required!";
          setErrors({ ...errors, primary_sector_experience: error });
        } else {
          setErrors({ ...errors, primary_sector_experience: null });
        }
        break;
      case "secondary_sector":
        if (value === null && inputData.secondary_sector_experience !== null) {
          const error = "Secondary Sector is required!";
          setErrors({ ...errors, secondary_sector: error });
        } else {
          setErrors({ ...errors, secondary_sector: null });
        }
        break;
      case "secondary_sector_experience":
        if (value === null && inputData.secondary_sector !== null) {
          const error = "Secondary Sector Experience is required!";
          setErrors({ ...errors, secondary_sector_experience: error });
        } else {
          setErrors({ ...errors, secondary_sector_experience: null });
        }
        break;
      default:
        break;
    }
  };

  const handleChange = (event, eventName) => {
    setIsEnable((prevState) => ({ ...prevState, save: true }));
    setCanShowDialogLeavingPage(true);
    if (eventName === "primary_sector" || eventName === "secondary_sector") {
      if (event != null) {
        setInputData((prevState) => ({
          ...prevState,
          [eventName]: event["id"],
        }));
        props.parentCallback(event["id"], eventName);
      } else {
        setInputData((prevState) => ({ ...prevState, [eventName]: null }));
        props.parentCallback(null, eventName);
      }
    } else {
      if (event.target.value === "") {
        setInputData((prevState) => ({
          ...prevState,
          [event.target.name]: null,
        }));
      } else {
        setInputData((prevState) => ({
          ...prevState,
          [event.target.name]: event.target.value,
        }));
      }
    }
  };

  const statutory = (primarySectorId, secondarySectorId) => {
    const statutoryIndustryTrainingData = props.statutoryIndustry.filter(
      (val) => [primarySectorId, secondarySectorId].includes(val["sector"])
    );

    const statutoryUserData = props.profile.statutory_industry;

    const updateStatutoryUserData = [];

    for (let i in statutoryUserData) {
      const valid = statutoryIndustryTrainingData.find(
        (row) => row.id === statutoryUserData[i]
      );
      if (valid) {
        updateStatutoryUserData.push(
          statutoryIndustryTrainingData.find(
            (row) => row.id === statutoryUserData[i]
          ).id
        );
      }
    }
    return updateStatutoryUserData;
  };

  const handleFormSubmit = (event) => {
    event.preventDefault();
    const updateSector = {
      userId: inputData.userId,
      primary_sector: inputData.primary_sector,
      primary_sector_experience: inputData.primary_sector_experience,
      secondary_sector: inputData.secondary_sector,
      secondary_sector_experience: inputData.secondary_sector_experience,
      statutory_industry: statutory(
        inputData.primary_sector,
        inputData.secondary_sector
      ),
    };

    for (const [key, value] of Object.entries(updateSector)) {
      handleValidations(key, value);
    }
    dispatch(updateProfleAction(inputData.userId, updateSector));
    setIsEnable((prevState) => ({ ...prevState, save: false }));
    setCanShowDialogLeavingPage(false);
  };

  useEffect(() => {
    if (Object.keys(props.profile).length > 0) {
      const sector = {
        userId: props.profile.userId,
        primary_sector: props.profile.primary_sector,
        primary_sector_experience: props.profile.primary_sector_experience,
        secondary_sector: props.profile.secondary_sector,
        secondary_sector_experience: props.profile.secondary_sector_experience,
      };
      setInputData(sector);
    }
  }, [props.profile]);

  return (
    <div className="row">
      <DialogLeavingPage
        showDialog={showDialogLeavingPage}
        setShowDialog={setCanShowDialogLeavingPage}
        confirmNavigation={confirmNavigation}
        cancelNavigation={cancelNavigation}
        title={"Sector"}
      />
      <div className="row-icon completed">
        <img src="/assets/images/profile-page/Sector_outline.svg" alt="" />
        {/* <img
          className="completed"
          src="/assets/images/profile-page/Recent_career_summary_active.svg"
          alt=""
        /> */}
      </div>
      <div className="col-12">
        <div className="timeline-border-box">
          <form>
            <h5>Sector</h5>
            <div className="row">
              <div className="col-md-6 col-12 " style={{ paddingTop: "1%" }}>
                <label className="field-label">Primary Sector</label>
                <div className="expertise-fields">
                  <div className="single-field mb-3">
                    <Select
                      id="primary_sector"
                      name="primary_sector"
                      value={
                        props.sector &&
                        props.sector.find(
                          (sector) => sector.id === inputData.primary_sector
                        )
                      }
                      options={props.sector}
                      getOptionLabel={(option) => option.sector}
                      getOptionValue={(option) => option.id}
                      onChange={(event) =>
                        handleChange(event, "primary_sector")
                      }
                      placeholder="Choose.."
                      styles={customStyles}
                      isClearable={true}
                    />
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-12 " style={{ paddingTop: "1%" }}>
                <label className="field-label">Years Of Experience</label>
                <div className="expertise-fields">
                  <div className="single-field mb-3">
                    <input
                      type="number"
                      className="form-control"
                      name="primary_sector_experience"
                      min="0"
                      placeholder="Primary Sector Years Of Experience"
                      onChange={(event) => handleChange(event)}
                      defaultValue={inputData.primary_sector_experience}
                    />
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-12">
                <label className="field-label">Secondary Sector</label>
                <div className="expertise-fields">
                  <div className="single-field mb-3">
                    <Select
                      id="secondary_sector"
                      name="secondary_sector"
                      value={
                        props.sector &&
                        props.sector.find(
                          (sector) => sector.id === inputData.secondary_sector
                        )
                      }
                      options={props.sector}
                      getOptionLabel={(option) => option.sector}
                      getOptionValue={(option) => option.id}
                      onChange={(event) =>
                        handleChange(event, "secondary_sector")
                      }
                      placeholder="Choose.."
                      styles={customStyles}
                      isDisabled={
                        inputData.primary_sector === null ? true : false
                      }
                      isClearable
                    />
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-12">
                <label className="field-label">Years Of Experience</label>
                <div className="expertise-fields">
                  <div className="single-field mb-3">
                    <input
                      type="number"
                      className="form-control"
                      min="0"
                      name="secondary_sector_experience"
                      placeholder="Secondary Sector Years Of Experience"
                      onChange={(event) => handleChange(event)}
                      defaultValue={inputData.secondary_sector_experience}
                    />
                  </div>
                </div>
              </div>
            </div>{" "}
            <div className="col text-right ">
              {isEnable.save ? (
                <Link className="edit-btn" to="" onClick={handleFormSubmit}>
                  
                  <span>
                    <img src="/assets/images/icons/save.png" alt="" />Save
                  </span>
                </Link>
              ) : (
                ""
              )}
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  const authUser = state.user.user;
  const userProfile = state.user.profile;
  const sector = state.admin.sector;
  const statutoryIndustry = state.admin.statutoryIndustry;

  return {
    user: authUser,
    profile: userProfile,
    sector: sector,
    statutoryIndustry: statutoryIndustry,
  };
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(Sector);
